import { Link } from 'react-router-dom';

export default function LeaveGamePopup({popupOpen, onSendLeaveGame}) {
    const sendValue = () => {
        console.log('test')
        onSendLeaveGame(false);
    };

    return (
        <div id="leaveGamePopup" className={`popup ${popupOpen ? "open" : ""}`}>
            <div className="popup-content">
                <div className="popup-text">
                    <h5>Êtes vous sûr de vouloir quitter ?</h5>
                </div>
                <div className="popup-btn-choice">
                    <button className="stay btn-full" onClick={sendValue}>Continuer à jouer</button>
                    <Link to="/themeSelector">
                        <button className="leave btn-empty">Quitter</button>
                    </Link>
                </div>
            </div>
        </div>
    );
}